export function getCurrentTimeFormatted() {
  const now = new Date()
  const hour = now
    .getHours()
    .toString()
    .padStart(2, '0')
  const minute = now
    .getMinutes()
    .toString()
    .padStart(2, '0')
  return `${hour}:${minute}`
}

export const days = [
  {
    name: 'Setiap Hari',
    value: 'everyday',
    start: getCurrentTimeFormatted(),
    end: getCurrentTimeFormatted(),
    fullDay: true,
    id: 0,
  },
  {
    name: 'Senin',
    value: 'monday',
    start: getCurrentTimeFormatted(),
    end: getCurrentTimeFormatted(),
    fullDay: false,
    id: 1,
  },
  {
    name: 'Selasa',
    value: 'tuesday',
    start: getCurrentTimeFormatted(),
    end: getCurrentTimeFormatted(),
    fullDay: false,
    id: 2,
  },
  {
    name: 'Rabu',
    value: 'wednesday',
    start: getCurrentTimeFormatted(),
    end: getCurrentTimeFormatted(),
    fullDay: false,
    id: 3,
  },
  {
    name: 'Kamis',
    value: 'thursday',
    start: getCurrentTimeFormatted(),
    end: getCurrentTimeFormatted(),
    fullDay: false,
    id: 4,
  },
  {
    name: 'Jumat',
    value: 'friday',
    start: getCurrentTimeFormatted(),
    end: getCurrentTimeFormatted(),
    fullDay: false,
    id: 5,
  },
  {
    name: 'Sabtu',
    value: 'saturday',
    start: getCurrentTimeFormatted(),
    end: getCurrentTimeFormatted(),
    fullDay: false,
    id: 6,
  },
  {
    name: 'Minggu',
    value: 'sunday',
    start: getCurrentTimeFormatted(),
    end: getCurrentTimeFormatted(),
    fullDay: false,
    id: 7,
  },
]

export const jobdescDefault = `Beri salam sesuai waktu:
* "Selamat pagi" (05:00-10:59)
* "Selamat siang" (11:00-14:59)
* "Selamat sore" (15:00-17:59)
* "Selamat malam" (18:00-04:59)

Hindari pengulangan nama agen atau sapaan berlebihan. Cukup beri salam sekali, lalu langsung lanjut ke tahap berikutnya.

Panduan Objection Handling yang Wajib Diikuti:
1. Menyambut, memperkenalkan diri, dan menanyakan identitas calon pembeli. Contoh: "Perkenalkan, saya dari ... . Boleh tahu dengan siapa dan domisili di desa/kecamatan/kota mana ya?"
2. Menawarkan daftar produk. Setelah mendapatkan nama dan lokasi calon pembeli, berikan daftar produk tanpa gambar lalu tanyakan minatnya: "Berikut beberapa pilihan produk kami. Apakah sudah ada yang cocok, atau ada yang ingin ditanyakan lebih lanjut?"
3. Menanyakan pilihan produk. Jika calon pembeli tertarik: "Mau pilih produk nomor berapa dan jumlahnya berapa, ya?"
4. Jika sudah memilih, tampilkan gambar produk.
5. Konfirmasi produk dan tawarkan tambahan. Setelah pembeli memilih produk: "Apakah ada produk lain yang ingin ditambahkan? Jika sudah cukup, akan hitungkan ongkos kirim berdasarkan berat dan jumlahnya."`
export const jobdesc = `Beri salam sesuai waktu:
* "Selamat pagi" (05:00-10:59)
* "Selamat siang" (11:00-14:59)
* "Selamat sore" (15:00-17:59)
* "Selamat malam" (18:00-04:59)

Hindari pengulangan nama agen atau sapaan berlebihan. Cukup beri salam sekali, lalu langsung lanjut ke tahap berikutnya.

Panduan Objection Handling yang Wajib Diikuti:
1. Menyambut, memperkenalkan diri, dan menanyakan identitas calon pembeli. Contoh: "Perkenalkan, saya dari ... . Boleh tahu dengan siapa dan domisili di desa/kecamatan/kota mana ya?"
2. Menawarkan daftar produk. Setelah mendapatkan nama dan lokasi calon pembeli, berikan daftar produk tanpa gambar lalu tanyakan minatnya: "Berikut beberapa pilihan produk kami. Apakah sudah ada yang cocok, atau ada yang ingin ditanyakan lebih lanjut?"
3. Menanyakan pilihan produk. Jika calon pembeli tertarik: "Mau pilih produk nomor berapa dan jumlahnya berapa, ya?"
4. Jika sudah memilih, tampilkan gambar produk.
5. Konfirmasi produk dan tawarkan tambahan. Setelah pembeli memilih produk: "Apakah ada produk lain yang ingin ditambahkan? Jika sudah cukup, akan hitungkan ongkos kirim berdasarkan berat dan jumlahnya."`

export const followUporder = [
  {
    id: 1,
    delay: 3,
    label: '3 jam dari chat terakhir',
    isActive: true,
    isOpenEdit: false,
    onEdit: false,
    message:
      'Hai Kak [Nama Customer], kami lihat proses pesanannya belum selesai. Apakah ada kendala yang bisa kami bantu? Atau mau melanjutkan pesanannya sekarang?',
  },
  {
    id: 2,
    delay: 24,
    label: '1 hari dari chat terakhir',
    isActive: true,
    isOpenEdit: false,
    onEdit: false,
    message:
      'Halo Kak [Nama Customer], Selamat [Waktu]. Sekadar mengingatkan tentang pesanan Kakak kemarin [Nama Produk]. Silakan konfirmasi jika Kakak masih ingin melanjutkan pesanan, agar dapat segera kami proses. Terima kasih!',
  },
  {
    id: 3,
    delay: 48,
    label: '2 hari dari chat terakhir',
    isActive: true,
    isOpenEdit: false,
    onEdit: false,
    message:
      'Halo Kak [Nama Customer], Selamat [Waktu] semoga kabarnya baik. Terima kasih sudah menyimak info [Nama Produk]. 😊 Ini pesan terakhir saya. Jika masih ada yang membuat ragu, silakan sampaikan. Kalau nanti berubah pikiran, jangan ragu hubungi kami ya. 🙏',
  },
]
export const followUporderDefault = [
  {
    id: 1,
    delay: 3,
    label: '3 jam dari chat terakhir',
    isActive: true,
    isOpenEdit: false,
    onEdit: false,
    message:
      'Hai Kak [Nama Customer], kami lihat proses pesanannya belum selesai. Apakah ada kendala yang bisa kami bantu? Atau mau melanjutkan pesanannya sekarang?',
  },
  {
    id: 2,
    delay: 24,
    label: '1 hari dari chat terakhir',
    isActive: true,
    isOpenEdit: false,
    onEdit: false,
    message:
      'Halo Kak [Nama Customer], Selamat [Waktu]. Sekadar mengingatkan tentang pesanan Kakak kemarin [Nama Produk]. Silakan konfirmasi jika Kakak masih ingin melanjutkan pesanan, agar dapat segera kami proses. Terima kasih!',
  },
  {
    id: 3,
    delay: 48,
    label: '2 hari dari chat terakhir',
    isActive: true,
    isOpenEdit: false,
    onEdit: false,
    message:
      'Halo Kak [Nama Customer], Selamat [Waktu] semoga kabarnya baik. Terima kasih sudah menyimak info [Nama Produk]. 😊 Ini pesan terakhir saya. Jika masih ada yang membuat ragu, silakan sampaikan. Kalau nanti berubah pikiran, jangan ragu hubungi kami ya. 🙏',
  },
]

export const stepsData = [
  {
    number: 1,
    name: 'AI Customer Service',
    done: false,
    step: 'one',
  },
  {
    number: 2,
    name: 'Produk',
    done: false,
    step: 'two',
  },
  {
    number: 3,
    name: 'Ekspedisi',
    done: false,
    step: 'three',
  },
  {
    number: 4,
    name: 'Jenis Pembayaran',
    done: false,
    step: 'four',
  },
  {
    number: 5,
    name: 'Pengaturan Tambahan',
    done: false,
    step: 'five',
  },
]
